import React from 'react';
import Container from '../../../containers/integration/functions/showFunctionContainer';

export default function () {
  return (
    <Container />
  );
}
